import { useEffect } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import * as yup from 'yup';

import { msCatalystApi } from '../../../../services/api/ms-catalyst-api.js';

import {
  AlertDialogCancel,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../ui/alert-dialog.jsx';
import { Button } from '../../../ui/button.jsx';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../ui/form.jsx';
import { PasswordInput } from '../../../ui/input-password.jsx';

export const FormAccountActionValidatePassword = ({
  actionTitle,
  onFormSuccess,
}) => {
  const formAccountActionValidatePassword = useForm({
    mode: 'onChange',
    defaultValues: {
      validatePassword: '',
    },
    resolver: yupResolver(
      yup.object().shape({
        validatePassword: yup
          .string()
          .required('Por favor insira a sua palavra-passe.'),
      }),
    ),
  });

  const mutationAccountValidateCurrentPassword = useMutation({
    mutationFn: async (data) => {
      await msCatalystApi.post(`/auth/password/validate`, {
        password: data.validatePassword,
      });

      onFormSuccess();

      formAccountActionValidatePassword.reset();

      return true;
    },
    onError: () => {
      toast.error('Ocorreu um erro ao validar a palavra-passe da sua conta', {
        description: 'Por favor tente novamente mais tarde',
      });
    },
  });

  useEffect(() => {
    if (formAccountActionValidatePassword.isSubmitSuccessful) {
      formAccountActionValidatePassword.reset();
    }
  }, [formAccountActionValidatePassword.formState]);

  return (
    <Form {...formAccountActionValidatePassword}>
      <form
        onSubmit={formAccountActionValidatePassword.handleSubmit(
          async (data) => {
            await mutationAccountValidateCurrentPassword.mutateAsync(data);
          },
        )}
      >
        <AlertDialogHeader>
          <AlertDialogTitle>{actionTitle}</AlertDialogTitle>
          <p className="text-sm text-muted-foreground">
            Por motivos de segurança necessitamos que confirme a sua
            palavra-passe
          </p>
        </AlertDialogHeader>

        <div className="grid grid-cols-1 py-6">
          <FormField
            control={formAccountActionValidatePassword.control}
            name="validatePassword"
            render={({ field }) => (
              <FormItem variant="portal">
                <FormLabel required={true}>Palavra-passe</FormLabel>
                <FormControl>
                  <PasswordInput {...field} autoComplete="off" />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel
            disabled={mutationAccountValidateCurrentPassword.isPending}
            onClick={() => formAccountActionValidatePassword.reset()}
          >
            Cancelar
          </AlertDialogCancel>

          <Button
            type="submit"
            variant="portal"
            disabled={
              !formAccountActionValidatePassword.formState.isDirty ||
              mutationAccountValidateCurrentPassword.isPending
            }
            isLoading={mutationAccountValidateCurrentPassword.isPending}
          >
            Confirmar
          </Button>
        </AlertDialogFooter>
      </form>
    </Form>
  );
};
